export default __webpack_public_path__ + "static/media/avatar.571be5bc.jpg";